import { api } from "api/apiService";

/**
 * Запитує у бекенда генерацію PDF-файлу з цінниками.
 * @param {string[]} skus - Масив артикулів (SKU) для друку.
 * @param {number} warehouse_id - ID складу.
 * @returns {Promise<Blob>} - Promise, який повертає PDF-файл у вигляді Blob.
 */
export const generatePricetagsPdf = (skus, warehouse_id) => {
  const data = {
    skus: skus,
    warehouse_id: warehouse_id,
  };

  return api.post("/pricetags/generate", data, {
    responseType: "blob",
  });
};
